import { LocalStorageKey, SessionStorageKey } from 'core-framework/constant/StorageKeys';
import { AppConfiguration } from 'core/configuration/AppConfiguration';
import { logWarn } from 'core-framework/util/LogMessage';

export const getSessionStorage = (windowArg = window) => windowArg.sessionStorage;
export const getLocalStorage = (windowArg = window) => windowArg.localStorage;

export const setItemInSessionStorage = (key: SessionStorageKey, value: string, sessionStorage = getSessionStorage(), isDev = AppConfiguration.isDev()) => {
    try {
        sessionStorage.setItem(key, value);
    } catch (e) {
        if (isDev && (e as Error).name === 'QuotaExceededError') {
            sessionStorage.clear();
        }
    }
};

export const setItemInLocalStorage = (key: LocalStorageKey, value: string, localStorage = getLocalStorage(), isDev = AppConfiguration.isDev()) => {
    try {
        localStorage.setItem(key, value);
    } catch (e) {
        if (isDev && (e as Error).name === 'QuotaExceededError') {
            localStorage.clear();
        }
    }
};

export const removeItemFromLocalStorage = (key: LocalStorageKey, localStorage = getLocalStorage()) => {
    localStorage.removeItem(key);
};

export const removeItemFromSessionStorage = (key: SessionStorageKey, sessionStorage = getSessionStorage()) => {
    sessionStorage.removeItem(key);
};

export const getItemFromLocalStorage = (key: LocalStorageKey, localStorage = getLocalStorage()): string | null => {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        logWarn(`localstorage is not supported in the browser: ${error}`, 0);
        return null;
    }
};

export const getItemFromSessionStorage = (key: SessionStorageKey, sessionStorage = getSessionStorage()): string | null => {
    try {
        return sessionStorage.getItem(key);
    } catch (error) {
        logWarn(`sessionStorage is not supported in the browser: ${error}`, 0);
        return null;
    }
};
